{
  "light": "retro",
  "dark": "abyss"
}
